module.exports = __webpack_public_path__ + "img/bg-bw.402fb0ea.png";